import './icons.css';

export const Pin = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9C12 7.9 11.1023 7 10.0052 7H9.97423H8.97681H7H2.99227V4C2.99227 2.346 4.3348 1 5.98454 1C7.63428 1 8.97681 2.346 8.97681 4H9.97423C9.97423 1.8 8.17887 0 5.98454 0C3.79021 0 1.99485 1.8 1.99485 4V7C0.897681 7 0 7.9 0 9V14C0 15.1 0.897681 16 1.99485 16H10.0052C11.1023 16 12 15.1 12 14V9ZM10.0052 15C10.5552 15 11.0026 14.5515 11.0026 14V9C11.0026 8.4485 10.5552 8 10.0052 8H9.97423H1.99485C1.44477 8 0.997423 8.4485 0.997423 9V14C0.997423 14.5515 1.44477 15 1.99485 15H10.0052ZM6.99742 10.5C6.99742 10.775 6.773 11 6.49871 11H5.50129C5.227 11 5.00258 10.775 5.00258 10.5C5.00258 10.225 5.227 10 5.50129 10H6.49871C6.773 10 6.99742 10.225 6.99742 10.5Z"
        fill="white"
      />
    </svg>
  );
};
export const Unpin = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.97412 7H10.0054C11.1025 7 12 7.9 12 9V14C12 15.1 11.1025 16 10.0054 16H1.99463C0.897461 16 0 15.1 0 14V9C0 7.9 0.897461 7 1.99463 7V4C1.99463 1.8 3.79004 0 5.98438 0C8.17871 0 9.97412 1.8 9.97412 4V7ZM5.98438 1C4.33496 1 2.99219 2.346 2.99219 4V7H8.97656V4C8.97656 2.346 7.63428 1 5.98438 1ZM11.0029 14C11.0029 14.5515 10.5552 15 10.0054 15H1.99512C1.44482 15 0.997559 14.5515 0.997559 14V9C0.997559 8.4485 1.44482 8 1.99512 8H9.97461H10.0054C10.5552 8 11.0029 8.4485 11.0029 9V14ZM6.49854 11C6.77295 11 6.99707 10.775 6.99707 10.5C6.99707 10.225 6.77295 10 6.49854 10H5.50098C5.22705 10 5.00244 10.225 5.00244 10.5C5.00244 10.775 5.22705 11 5.50098 11H6.49854Z"
        fill="white"
      />
    </svg>
  );
};
export const Calendar = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      style={style}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
      />
    </svg>
  );
};

export const Half = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 16 16" style={style}>
      <defs />
      <rect
        x="1.0"
        y="9.5"
        width="13.0"
        height="5.5"
        rx="2"
        fill="none"
        stroke={style?.color as string}
        strokeWidth="1"
      />
      <polygon
        fill={style?.color as string}
        points="0.0,7.5 0.0,8.0 15.5,8.0 15.5,7.5"
        stroke={style?.color as string}
        strokeWidth="0.5"
      />
      <rect
        x="1.0"
        y="0.5"
        width="13.0"
        height="5.5"
        rx="2"
        fill="none"
        stroke={style?.color as string}
        strokeWidth="1"
      />
    </svg>
  );
};

export const FullScreen = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" style={style}>
      <path style={{ fill: '#ffffff', stroke: 'none' }} d="M0 0L0 10L2 10L2 2L30 2L30 29L22 29L22 32L32 32L32 0L0 0z" />
      <path
        style={{ fill: 'none', stroke: 'none' }}
        d="M2 2C1.95905 5.70005 1.31693 8.56303 0 12L20 12L20 32C21.7833 31.0198 21.5943 31.0924 22 29L30 29L30 2L2 2z"
      />
      <path
        style={{ fill: '#ffffff', stroke: 'none' }}
        d="M17 7L21 7C19.9435 9.24249 19.8185 9.57662 20 12C21.4162 11.5279 21.8137 11.1863 23 10C23.4824 12.364 23.636 12.5176 26 13L26 4C22.2312 4.01332 19.1729 3.64837 17 7M0 12L0 32L20 32L20 12L0 12z"
      />
      <path style={{ fill: '#012854', stroke: 'none' }} d="M2 15L2 30L18 30L18 15L2 15z" />
    </svg>
  );
};

export const Info = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={style}>
      <path
        fillRule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export const ChevronDown = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" fill="none" />
    </svg>
  );
};

export const ChevronUp = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" fill="none" />
    </svg>
  );
};

export const ChevronDoubleRight = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
    </svg>
  );
};
export const ChevronDoubleLeft = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
    </svg>
  );
};
export const ChevronLeft = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
    </svg>
  );
};
export const ChevronRight = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={style}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </svg>
  );
};
export const Xmark = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      style={style}
    >
      <path style={style} strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  );
};

export const Pen = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.2 16" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24 12.8878L2.64 14.404H15.2V16H0V14.5636C0 14.404 0 14.2444 0.08 14.1646L2.32 8.89776C2.32 8.57855 2.48 8.33915 2.64 8.17955L9.68 0.359102C10.24 -0.119701 11.04 -0.119701 11.6 0.359102L14 2.75312C14.56 3.31172 14.56 4.10973 14 4.66833L6.96 12.5686C6.72 12.7282 6.48 12.808 6.24 12.8878ZM11.2 1.87531C10.96 1.63591 10.48 1.63591 10.24 1.87531L8.88 3.31172L11.2 5.70574L12.64 4.26933C12.88 4.02993 12.88 3.55112 12.64 3.31172L11.2 1.87531ZM8 4.18953L10.4 6.58354L6.16 11.5312L3.76 9.13716L8 4.18953ZM2.88 10.414L1.36 13.3666C1.28 13.5262 1.36 13.7656 1.52 13.8454C1.6 13.9252 1.76 13.9252 1.84 13.8454L4.8 12.3292L2.88 10.414Z"
      />
    </svg>
  );
};
export const Check = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      style={{ ...style, stroke: style?.color }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" fill="none" />
    </svg>
  );
};

export const Trash = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, marginLeft: '4px', marginRight: '4px' }}
    >
      <rect x="5" y="9" width="22" height="22" stroke="#002854" strokeWidth="2" />
      <line y1="5" x2="32" y2="5" stroke="#002854" strokeWidth="2" />
      <line x1="10" y1="13" x2="10" y2="28" stroke="#002854" strokeWidth="2" />
      <line x1="16" y1="13" x2="16" y2="28" stroke="#002854" strokeWidth="2" />
      <line x1="22" y1="13" x2="22" y2="28" stroke="#002854" strokeWidth="2" />
      <line x1="9" y1="1" x2="23" y2="1" stroke="#002854" strokeWidth="2" />
    </svg>
  );
};
export const CarGreen = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M18.5 4C19.325 4 20 4.675 20 5.5V7.29199H24.5C24.716 7.29199 24.7864 7.35531 24.9004 7.50781C24.9014 7.50878 24.9024 7.50978 24.9033 7.51074L27.8945 11.9678C27.8945 11.9678 27.9999 12.0999 28 12.2344V21C28 21.276 27.776 21.5 27.5 21.5H25.9551C25.7166 22.9185 24.486 24 23 24C21.514 24 20.2834 22.9185 20.0449 21.5H12.4551C12.2166 22.9185 10.986 24 9.5 24C8.014 24 6.78342 22.9185 6.54492 21.5H5.01562C4.7398 21.4998 4.51562 21.2759 4.51562 21C4.51562 20.7241 4.7398 20.5002 5.01562 20.5H6.54492C6.64092 19.9285 6.89805 19.413 7.26855 19H5.5C4.675 19 4 18.325 4 17.5V5.5C4 4.675 4.675 4 5.5 4H18.5ZM9.5 18.999C8.39716 18.999 7.50026 19.8962 7.5 20.999C7.5 22.102 8.397 22.999 9.5 22.999C10.603 22.999 11.5 22.102 11.5 20.999C11.4997 19.8962 10.6028 18.999 9.5 18.999ZM23 18.999C21.8972 18.999 21.0003 19.8962 21 20.999C21 22.102 21.897 22.999 23 22.999C24.103 22.999 25 22.102 25 20.999C24.9997 19.8962 24.1028 18.999 23 18.999ZM20 17.499C20 18.324 19.325 18.999 18.5 18.999H11.7314C12.1018 19.4119 12.359 19.9277 12.4551 20.499H20.0449C20.2836 19.0812 21.5142 17.999 23 17.999C24.4858 17.999 25.7164 19.0807 25.9551 20.499H27V12.499H22C21.724 12.499 21.5 12.275 21.5 11.999V8.29102H20V17.499ZM5.5 4.99902C5.22916 4.99902 5.00027 5.22823 5 5.49902V17.499C5 17.77 5.229 17.999 5.5 17.999H18.5C18.771 17.999 19 17.77 19 17.499V5.49902C18.9997 5.22823 18.7708 4.99902 18.5 4.99902H5.5ZM22.5 11.499H26.4082L24.2256 8.29102H22.5V11.499Z"
        fill="#9A9EA2"
      />
      <circle cx="6" cy="6" r="6" fill="#58C640" />
    </svg>
  );
};
export const Restore = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, marginLeft: '4px', marginRight: '4px' }}
    >
      <path d="M256 8C119 8 8 119.03 8 256h48c0-110.28 89.72-200 200-200s200 89.72 200 200-89.72 200-200 200c-47.86 0-91.81-16.87-126.1-44.86l35.88-35.88H64v109.25l40.16-40.15C144.96 479.36 197.97 504 256 504c136.97 0 248-111.03 248-248S392.97 8 256 8zm5 112c-11.05 0-20 8.95-20 20v104c0 7.06 3.72 13.58 9.86 17.18l80.2 47.34c9.53 5.62 21.8 2.39 27.42-7.14 5.62-9.53 2.39-21.8-7.14-27.42L281 247.41V140c0-11.05-8.95-20-20-20z" />
    </svg>
  );
};
export const CarRed = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M18.5 4C19.325 4 20 4.675 20 5.5V7.29199H24.5C24.716 7.29199 24.7864 7.35531 24.9004 7.50781C24.9014 7.50878 24.9024 7.50978 24.9033 7.51074L27.8945 11.9678C27.8945 11.9678 27.9999 12.0999 28 12.2344V21C28 21.276 27.776 21.5 27.5 21.5H25.9551C25.7166 22.9185 24.486 24 23 24C21.514 24 20.2834 22.9185 20.0449 21.5H12.4551C12.2166 22.9185 10.986 24 9.5 24C8.014 24 6.78342 22.9185 6.54492 21.5H5.01562C4.7398 21.4998 4.51562 21.2759 4.51562 21C4.51562 20.7241 4.7398 20.5002 5.01562 20.5H6.54492C6.64092 19.9285 6.89805 19.413 7.26855 19H5.5C4.675 19 4 18.325 4 17.5V5.5C4 4.675 4.675 4 5.5 4H18.5ZM9.5 18.999C8.39716 18.999 7.50026 19.8962 7.5 20.999C7.5 22.102 8.397 22.999 9.5 22.999C10.603 22.999 11.5 22.102 11.5 20.999C11.4997 19.8962 10.6028 18.999 9.5 18.999ZM23 18.999C21.8972 18.999 21.0003 19.8962 21 20.999C21 22.102 21.897 22.999 23 22.999C24.103 22.999 25 22.102 25 20.999C24.9997 19.8962 24.1028 18.999 23 18.999ZM20 17.499C20 18.324 19.325 18.999 18.5 18.999H11.7314C12.1018 19.4119 12.359 19.9277 12.4551 20.499H20.0449C20.2836 19.0812 21.5142 17.999 23 17.999C24.4858 17.999 25.7164 19.0807 25.9551 20.499H27V12.499H22C21.724 12.499 21.5 12.275 21.5 11.999V8.29102H20V17.499ZM5.5 4.99902C5.22916 4.99902 5.00027 5.22823 5 5.49902V17.499C5 17.77 5.229 17.999 5.5 17.999H18.5C18.771 17.999 19 17.77 19 17.499V5.49902C18.9997 5.22823 18.7708 4.99902 18.5 4.99902H5.5ZM22.5 11.499H26.4082L24.2256 8.29102H22.5V11.499Z"
        fill="#9A9EA2"
      />
      <circle cx="6" cy="6" r="6" fill="#FF0200" />
    </svg>
  );
};
export const SortableDown = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" fill="none" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92533 6.5435C2.92533 6.29242 2.72533 6.087 2.48089 6.087H0.444444C0.2 6.087 0 6.29242 0 6.5435C0 6.79457 0.2 7 0.444444 7H2.48089C2.72533 7 2.92533 6.79457 2.92533 6.5435ZM5.49956 3.50046C5.49956 3.24938 5.29956 3.04395 5.05511 3.04395H0.444444C0.2 3.04395 0 3.24938 0 3.50046C0 3.75062 0.2 3.95696 0.444444 3.95696H5.05511C5.29956 3.95696 5.49956 3.75062 5.49956 3.50046ZM7.55556 0.913004H0.444444C0.2 0.913004 0 0.707578 0 0.456502C0 0.206339 0.2 0 0.444444 0H7.55556C7.79911 0 8 0.206339 8 0.456502C8 0.707578 7.79911 0.913004 7.55556 0.913004Z"
        fill="var(--primary-color-300)"
      />
    </svg>
  );
};
export const SortableUp = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 7" fill="none" style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92533 0.456502C2.92533 0.707578 2.72533 0.913004 2.48089 0.913004H0.444444C0.2 0.913004 0 0.707578 0 0.456502C0 0.205426 0.2 0 0.444444 0H2.48089C2.72533 0 2.92533 0.205426 2.92533 0.456502ZM5.49956 3.49954C5.49956 3.75062 5.29956 3.95605 5.05511 3.95605H0.444444C0.2 3.95605 0 3.75062 0 3.49954C0 3.24938 0.2 3.04304 0.444444 3.04304H5.05511C5.29956 3.04304 5.49956 3.24938 5.49956 3.49954ZM7.55556 6.087H0.444444C0.2 6.087 0 6.29242 0 6.5435C0 6.79366 0.2 7 0.444444 7H7.55556C7.79911 7 8 6.79366 8 6.5435C8 6.29242 7.79911 6.087 7.55556 6.087Z"
        fill="var(--primary-color-300)"
      />
    </svg>
  );
};

export const Processing = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg className="spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style={style}>
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" color="#ffe4c400"></circle>
      <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  );
};

export const Search = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
      style={style}
    >
      <path
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
      />
    </svg>
  );
};

export const Bell = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    style={style}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin={'round'}
      d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5"
    />
  </svg>
);

export const FolderClosed = ({ style }: { style?: React.CSSProperties }) => (
  <svg style={style} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ic_group_close">
      <path
        id="Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0123 6.29761L14.984 9.33517C14.984 9.65015 15.2045 9.86777 15.4979 9.86777C15.7912 9.86777 15.9951 9.63271 15.9951 9.31774L16.0074 5.88976C16.0074 5.57479 15.7674 5.31708 15.4741 5.31708L9.28278 5.30381L6.5248 0.500874C6.39787 0.319336 6.18773 0.246606 5.99253 0.288411C5.96853 0.284975 0.533333 0.272949 0.533333 0.272949C0.24 0.272949 0 0.530654 0 0.845626V15.7112C0 16.0502 0.24 16.3079 0.533333 16.3079H8C8.29333 16.3079 8.53137 16.1089 8.53137 15.7939C8.53137 15.4789 8.31329 15.3004 8.01996 15.3004L0.995789 15.3061L1.02325 6.31651L15.0123 6.29761ZM8.03137 5.29365L0.989563 5.29347L1.00726 1.28792L5.79333 1.29061L8.03137 5.29365ZM13.2857 16.1586L15.8517 13.5011C16.0494 13.2964 16.0494 12.9618 15.8517 12.7571L15.8404 12.7454C15.6427 12.5406 15.3196 12.5406 15.122 12.7454L12.9027 15.0437L10.6834 12.7454C10.4858 12.5406 10.1627 12.5406 9.96502 12.7454L9.95366 12.7571C9.75599 12.9618 9.75599 13.2964 9.95366 13.5011L12.5198 16.1586C12.6245 16.2671 12.7644 16.3142 12.9027 16.3072C13.0405 16.3142 13.1809 16.2671 13.2857 16.1586Z"
        fill="var(--primary-color)"
      />
    </g>
  </svg>
);

export const FolderOpened = ({ style }: { style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" style={style} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9845 10.1272C14.9845 10.4212 15.1931 10.6753 15.4769 10.6753C15.7608 10.6753 15.993 10.4347 15.993 10.1408L16.0055 5.67056C16.0055 5.37659 15.7732 5.13606 15.4894 5.13606L9.3125 5.08804L6.31407 0.289144C6.19123 0.11971 5.98789 0.0518293 5.79899 0.0908473C5.77577 0.0876404 0.516108 0.076416 0.516108 0.076416C0.232249 0.076416 0 0.316938 0 0.610909V14.4853C0 14.8017 0.245694 15.1088 0.529553 15.1088L7.75122 15.1161C8.03508 15.1161 8.15917 14.8819 8.15917 14.5879C8.15917 14.2939 8.02494 14.1229 7.74108 14.1229L1.00182 14.108L1.01973 6.0837L15.003 6.11716L14.9845 10.1272ZM8.01414 5.09986L0.984297 5.07716L1.01031 1.09113L5.60305 1.09497L8.01414 5.09986ZM15.8404 15.9578L15.8517 15.9461C16.0494 15.7414 16.0494 15.4068 15.8517 15.202L13.2857 12.5445C13.1809 12.436 13.041 12.389 12.9027 12.396C12.7649 12.389 12.6245 12.436 12.5198 12.5445L9.95366 15.202C9.75599 15.4068 9.75599 15.7414 9.95366 15.9461L9.96502 15.9578C10.1627 16.1625 10.4858 16.1625 10.6834 15.9578L12.9027 13.6595L15.122 15.9578C15.3196 16.1625 15.6427 16.1625 15.8404 15.9578Z"
      fill="var(--primary-color)"
    />
  </svg>
);

export const List = ({ style }: { style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" style={style} viewBox="0 0 16 14" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0C0.8955 0 0 0.894295 0 1.99731C0 3.10032 0.8955 3.99462 2 3.99462C3.1045 3.99462 4 3.10032 4 1.99731C4 0.894295 3.1045 0 2 0ZM2 2.99596C1.4485 2.99596 1 2.54807 1 1.99731C1 1.44655 1.4485 0.998654 2 0.998654C2.5515 0.998654 3 1.44655 3 1.99731C3 2.54807 2.5515 2.99596 2 2.99596ZM0 12.0048C0 10.9018 0.8955 10.0075 2 10.0075C3.1045 10.0075 4 10.9018 4 12.0048C4 13.1078 3.1045 14.0021 2 14.0021C0.8955 14.0021 0 13.1078 0 12.0048ZM2 13.0035C1.4485 13.0035 1 12.5556 1 12.0048C1 11.4541 1.4485 11.0062 2 11.0062C2.5515 11.0062 3 11.4541 3 12.0048C3 12.5556 2.5515 13.0035 2 13.0035ZM0 6.99058C0 5.88757 0.8955 4.99327 2 4.99327C3.1045 4.99327 4 5.88757 4 6.99058C4 8.09359 3.1045 8.98789 2 8.98789C0.8955 8.98789 0 8.09359 0 6.99058ZM2 7.98923C1.4485 7.98923 1 7.54134 1 6.99058C1 6.43982 1.4485 5.99192 2 5.99192C2.5515 5.99192 3 6.43982 3 6.99058C3 7.54134 2.5515 7.98923 2 7.98923ZM15.5 7.51088C15.775 7.51088 16 7.28618 16 7.01155C16 6.73692 15.775 6.51222 15.5 6.51222H6.5C6.225 6.51222 6 6.73692 6 7.01155C6 7.28618 6.225 7.51088 6.5 7.51088H15.5ZM6 1.99731C6 1.72268 6.225 1.49798 6.5 1.49798H15.5C15.775 1.49798 16 1.72268 16 1.99731C16 2.27194 15.775 2.49664 15.5 2.49664H6.5C6.225 2.49664 6 2.27194 6 1.99731ZM15.5 12.5041C15.775 12.5041 16 12.2795 16 12.0048C16 11.7302 15.775 11.5055 15.5 11.5055H6.5C6.225 11.5055 6 11.7302 6 12.0048C6 12.2795 6.225 12.5041 6.5 12.5041H15.5Z"
      fill="#8095AC"
    />
  </svg>
);

export const CreateFolder = ({ style }: { style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" style={style} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.72836 4.99327H13.9638V7.48991C13.9638 7.76454 14.1882 7.98923 14.4625 7.98923C14.7368 7.98923 14.9612 7.76454 14.9612 7.48991V4.49394C14.9612 4.21931 14.7368 3.99462 14.4625 3.99462H8.95028L6.10118 0.198732C5.98248 0.0404455 5.78599 -0.022969 5.60347 0.0134818C5.58102 0.0104859 0.498706 0 0.498706 0C0.224418 0 0 0.224697 0 0.499327V13.4818C0 13.4836 0.000498706 13.4853 0.000997413 13.4871C0.00149612 13.4888 0.00199483 13.4906 0.00199483 13.4923C0.00199483 13.4941 0.00149612 13.4958 0.000997413 13.4976C0.000498706 13.4993 0 13.5011 0 13.5028C0 13.7774 0.224418 14.0021 0.498706 14.0021H6.48318C6.75747 14.0021 6.98189 13.7774 6.98189 13.5028C6.98189 13.2282 6.75747 13.0035 6.48318 13.0035H0.997413V4.99327C0.997413 4.99327 8.69345 4.99477 8.72836 4.99327ZM7.70252 3.99462H0.997413V0.998654H5.45385L7.70252 3.99462ZM15.5013 12.993C15.7756 12.993 16 12.7683 16 12.4937C16 12.219 15.7756 11.9943 15.5013 11.9943H12.9973V9.48721C12.9973 9.21258 12.7729 8.98789 12.4986 8.98789C12.2243 8.98789 11.9999 9.21258 11.9999 9.48721V11.9943H9.49587C9.22158 11.9943 8.99716 12.219 8.99716 12.4937C8.99716 12.7683 9.22158 12.993 9.49587 12.993H11.9999V15.5001C11.9999 15.7747 12.2243 15.9994 12.4986 15.9994C12.7729 15.9994 12.9973 15.7747 12.9973 15.5001V12.993H15.5013Z"
      fill="#8095AC"
    />
  </svg>
);

export const Delete = ({ style }: { style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" style={style} viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4258 8.75V16.875C14.4258 17.2188 14.1445 17.5 13.8008 17.5C13.457 17.5 13.1758 17.2188 13.1758 16.875V8.75C13.1758 8.40625 13.457 8.125 13.8008 8.125C14.1445 8.125 14.4258 8.40625 14.4258 8.75ZM10.6758 8.75V16.875C10.6758 17.2188 10.3945 17.5 10.0508 17.5C9.70703 17.5 9.42578 17.2188 9.42578 16.875V8.75C9.42578 8.40625 9.70703 8.125 10.0508 8.125C10.3945 8.125 10.6758 8.40625 10.6758 8.75ZM6.92578 8.75V16.875C6.92578 17.2188 6.64453 17.5 6.30078 17.5C5.95703 17.5 5.67578 17.2188 5.67578 16.875V8.75C5.67578 8.40625 5.95703 8.125 6.30078 8.125C6.64453 8.125 6.92578 8.40625 6.92578 8.75ZM5.625 0.625C5.625 0.28125 5.90625 0 6.25 0H13.75C14.0938 0 14.375 0.28125 14.375 0.625C14.375 0.96875 14.0938 1.25 13.75 1.25H6.25C5.90625 1.25 5.625 0.96875 5.625 0.625ZM20 3.125C20 3.46875 19.7188 3.75 19.375 3.75H0.625C0.28125 3.75 0 3.46875 0 3.125C0 2.78125 0.28125 2.5 0.625 2.5H19.375C19.7188 2.5 20 2.78125 20 3.125ZM3.4375 18.75H16.5625V6.25H3.4375V18.75ZM2.1875 18.75C2.1875 19.4375 2.74938 20 3.4375 20H16.5625C17.25 20 17.8125 19.4375 17.8125 18.75V5H2.1875V18.75Z"
      fill="var(--primary-color)"
    />
  </svg>
);

export const Reload = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    style={style}
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="#002854"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </svg>
);

export const Cross = ({ style }: { style?: React.CSSProperties }) => (
  <svg xmlns="http://www.w3.org/2000/svg" style={style} width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M0 6.67145C0 6.39531 0.223858 6.17145 0.5 6.17145H13.2143C13.4904 6.17145 13.7143 6.39531 13.7143 6.67145C13.7143 6.94759 13.4904 7.17145 13.2143 7.17145H0.5C0.223857 7.17145 0 6.94759 0 6.67145Z"
      fill="white"
    />
    <path
      d="M6.6709 13.7143C6.39476 13.7143 6.1709 13.4904 6.1709 13.2143L6.1709 0.500009C6.1709 0.223866 6.39476 8.58307e-06 6.6709 8.58307e-06C6.94704 8.58307e-06 7.1709 0.223866 7.1709 0.500009L7.1709 13.2143C7.1709 13.4904 6.94704 13.7143 6.6709 13.7143Z"
      fill="white"
    />
  </svg>
);

export const Globe = ({ style }: { style?: React.CSSProperties }) => (
  <svg style={style} width={14} height={14} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs></defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icon-Set" transform="translate(-204.000000, -671.000000)" fill="#fff">
        <path
          d="M231.596,694.829 C229.681,694.192 227.622,693.716 225.455,693.408 C225.75,691.675 225.907,689.859 225.957,688 L233.962,688 C233.783,690.521 232.936,692.854 231.596,694.829 L231.596,694.829 Z M223.434,700.559 C224.1,698.95 224.645,697.211 225.064,695.379 C226.862,695.645 228.586,696.038 230.219,696.554 C228.415,698.477 226.073,699.892 223.434,700.559 L223.434,700.559 Z M220.971,700.951 C220.649,700.974 220.328,701 220,701 C219.672,701 219.352,700.974 219.029,700.951 C218.178,699.179 217.489,697.207 216.979,695.114 C217.973,695.027 218.98,694.976 220,694.976 C221.02,694.976 222.027,695.027 223.022,695.114 C222.511,697.207 221.822,699.179 220.971,700.951 L220.971,700.951 Z M209.781,696.554 C211.414,696.038 213.138,695.645 214.936,695.379 C215.355,697.211 215.9,698.95 216.566,700.559 C213.927,699.892 211.586,698.477 209.781,696.554 L209.781,696.554 Z M208.404,694.829 C207.064,692.854 206.217,690.521 206.038,688 L214.043,688 C214.093,689.859 214.25,691.675 214.545,693.408 C212.378,693.716 210.319,694.192 208.404,694.829 L208.404,694.829 Z M208.404,679.171 C210.319,679.808 212.378,680.285 214.545,680.592 C214.25,682.325 214.093,684.141 214.043,686 L206.038,686 C206.217,683.479 207.064,681.146 208.404,679.171 L208.404,679.171 Z M216.566,673.441 C215.9,675.05 215.355,676.789 214.936,678.621 C213.138,678.356 211.414,677.962 209.781,677.446 C211.586,675.523 213.927,674.108 216.566,673.441 L216.566,673.441 Z M219.029,673.049 C219.352,673.027 219.672,673 220,673 C220.328,673 220.649,673.027 220.971,673.049 C221.822,674.821 222.511,676.794 223.022,678.886 C222.027,678.973 221.02,679.024 220,679.024 C218.98,679.024 217.973,678.973 216.979,678.886 C217.489,676.794 218.178,674.821 219.029,673.049 L219.029,673.049 Z M223.954,688 C223.9,689.761 223.74,691.493 223.439,693.156 C222.313,693.058 221.168,693 220,693 C218.832,693 217.687,693.058 216.562,693.156 C216.26,691.493 216.1,689.761 216.047,688 L223.954,688 L223.954,688 Z M216.047,686 C216.1,684.239 216.26,682.507 216.562,680.844 C217.687,680.942 218.832,681 220,681 C221.168,681 222.313,680.942 223.438,680.844 C223.74,682.507 223.9,684.239 223.954,686 L216.047,686 L216.047,686 Z M230.219,677.446 C228.586,677.962 226.862,678.356 225.064,678.621 C224.645,676.789 224.1,675.05 223.434,673.441 C226.073,674.108 228.415,675.523 230.219,677.446 L230.219,677.446 Z M231.596,679.171 C232.936,681.146 233.783,683.479 233.962,686 L225.957,686 C225.907,684.141 225.75,682.325 225.455,680.592 C227.622,680.285 229.681,679.808 231.596,679.171 L231.596,679.171 Z M220,671 C211.164,671 204,678.163 204,687 C204,695.837 211.164,703 220,703 C228.836,703 236,695.837 236,687 C236,678.163 228.836,671 220,671 L220,671 Z"
          id="globe"
        ></path>
      </g>
    </g>
  </svg>
);

export const Tree = ({ style }: { style?: React.CSSProperties }) => (
  <svg style={style} width={14} height={14} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 113.84 122.88">
    <path
      fill="#8095AC"
      className="cls-1"
      d="M1.78,4,.18,7.55H44.23L42.61,4H23a1.17,1.17,0,0,1-1.18-1.17V0H5.05V2.81A1.17,1.17,0,0,1,3.87,4Zm67.7,95.21,2.88,22.22a1.49,1.49,0,0,0,1.36,1.47h35c.81,0,1.26-.78,1.36-1.5l3.73-22.19Zm1.78-5.77L69.66,97h44l-1.62-3.57H92.44a1.17,1.17,0,0,1-1.18-1.17V89.44H74.52v2.81a1.17,1.17,0,0,1-1.17,1.17ZM66.87,55.49l2.89,22.22a1.48,1.48,0,0,0,1.35,1.47h35c.81,0,1.26-.78,1.36-1.5l3.73-22.19Zm1.78-5.77-1.6,3.57H111.1l-1.62-3.57H89.83a1.17,1.17,0,0,1-1.17-1.18v-2.8H71.92v2.81a1.18,1.18,0,0,1-1.18,1.17ZM25.18,62.65H58.7v6H25.18v42H58.37v6H19.18V37.71h6V62.65ZM0,9.75,2.88,32a1.5,1.5,0,0,0,1.36,1.47h35c.81,0,1.26-.78,1.36-1.5L44.36,9.75Z"
    />
  </svg>
);

export const ArrowLeft = ({ style }: { style?: React.CSSProperties }) => (
  <svg width="16" style={style} height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="Fill 2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 6C16 6.32366 15.743 6.58907 15.4285 6.58907H1.95L6.2255 10.9955C6.448 11.2244 6.448 11.599 6.2255 11.8284C6.0035 12.0572 5.64 12.0572 5.4175 11.8284L0.1705 6.41952L0.1665 6.41694C0.055 6.30201 0 6.151 0 6C0 5.849 0.055 5.69747 0.1665 5.58255L0.1705 5.58048L5.4175 0.17162C5.64 -0.0572067 6.0035 -0.0572067 6.2255 0.17162C6.448 0.400447 6.448 0.775124 6.2255 1.00447L1.95 5.41093H15.4285C15.743 5.41093 16 5.67634 16 6Z"
      fill="#002854"
    />
  </svg>
);
